// lingland-frontend/src/index.js
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Import konfiguracji i18next
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Suspense jest potrzebny, ponieważ i18next może ładować tłumaczenia asynchronicznie */}
    <Suspense fallback="...loading">
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();